import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, Input, OnChanges, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { DateProviderService } from '@frontend/sports/common/core/utils/date';
import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';

import { CrmPromotionProviderService, PromotionMap } from '../../../crm-promotion/crm-promotion-provider.service';
import { HorsesFixtureHelper } from '../../../horse-racing-shared/services/horses-fixture-helper.service';
import { HorsesFixtureParticipantHelper } from '../../../horse-racing-shared/services/horses-fixture-participant-helper.service';
import { UrlHelperService } from '../../../navigation-core/url-helper.service';
import { HorseRacingTrackingService } from '../../common/horse-racing-tracking.service';

@Component({
    selector: 'ms-next-races-card-preview',
    templateUrl: './next-races-card-preview.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NextRacesCardPreviewComponent implements OnChanges, OnInit {
    @Input() race: WinGameFixture;
    @Input() trackingPosition: string;

    promotedFixtureIdsMap: StringDictionary<string> = {};
    timeInSeconds: number;
    participantsLength = 0;
    readonly maxChars = 30;
    display = false;
    viewFullRace: string = this.sitecore.horseRacing.nextThreeRaces.ViewFullRace;
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private urlHelper: UrlHelperService,
        public sitecore: Sitecore,
        private horseRacingTrackingService: HorseRacingTrackingService,
        private crmPromotionProvider: CrmPromotionProviderService,
        private changeDetector: ChangeDetectorRef,
        private horseFixtureHelper: HorsesFixtureHelper,
        private horseFixtureParticipantHelper: HorsesFixtureParticipantHelper,
    ) {}

    ngOnChanges(): void {
        this.participantsLength = this.horseFixtureParticipantHelper.getRunnersCount(this.race);
    }

    ngOnInit(): void {
        this.crmPromotionProvider.promotionsMap$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((ids) => this.promotionMapChanged(ids));
        this.timeInSeconds = DateProviderService.getTimeDifference(new Date(this.race.startDate), true);
    }

    onDisplay($event: boolean) {
        this.display = $event;
    }

    getFixtureLink(fixture: WinGameFixture): string {
        return this.urlHelper.getRacingUrlByFixture(fixture.sport.id, fixture);
    }

    private promotionMapChanged(promoMap: PromotionMap): void {
        this.promotedFixtureIdsMap = promoMap.fixtures;
        this.changeDetector.markForCheck();
    }

    track(race: WinGameFixture, value?: string): void {
        this.horseRacingTrackingService.trackRaceView(race, this.trackingPosition, value);
    }

    updateStatus(fixture: WinGameFixture): string | undefined {
        return this.horseFixtureHelper.updateStatus(fixture);
    }
}
